import { useMemo } from "react";
import color from "../../../../theme/color";
import { TextTag } from "../../../Tags/Text";
import { TagSizes } from "../../../Tags/utils/theme";

/**
 * 주문상태 enum
 * @notice 전체
 * -- 세차권 및 반품 추가
 */
export enum OrderStatus {
  /**
   * @notice 공통
   */
  /**
   * 주문취소
   */
  CANCELED_ORDER = "주문취소",
  /**
   * 결제완료
   */
  COMPLETED_PAYMENT = "결제완료",
  /**
   * 주문확정
   */
  CONFIRMED_ORDER = "주문확정",
  /**
   * 출고의뢰
   */
  REQUESTED_GOODS_ISSUE = "출고의뢰",
  /**
   * 출고완료
   */
  COMPLETED_GOODS_ISSUE = "출고완료",
  /**
   * 작업완료
   */
  COMPLETED_SERVICE = "작업완료",
  /**
   * 배송완료
   */
  COMPLETED_DELIVERY = "배송완료",
  /**
   * 구매확정
   */
  CONFIRMED_PURCHASE = "구매확정",

  /**
   * @notice 세차권
   */
  /**
   * 발급취소
   */
  CANCELED_ISSUE = "발급취소",
  /**
   * 발급완료
   */
  COMPLETED_ISSUE = "발급완료",
  /**
   * 기간만료
   */
  EXPIRED = "기간만료",
  /**
   * 사용완료
   */
  USED = "사용완료",
  /**
   * 사용완료확인
   */
  CONFIRMED_USING = "사용완료확인",

  /**
   * @notice 반품요청
   */
  /**
   * 반품요청
   */
  REQUESTED_RETURN = "반품요청",
  /**
   * 반품승인
   */
  CONFIRMED_RETURN = "반품승인",
  /**
   * 회수신청
   */
  APPLIED_RETURN = "회수준비중",
  /**
   * 회수완료
   */
  COMPLETED_DELIVERY_RETURN = "회수완료",
  /**
   * 반품완료
   */
  COMPLETED_RETURN = "반품완료",

  /**
   * @notice 환불
   */
  /**
   * 환불완료
   */
  COMPLETED_REFUND = "환불완료",
  /**
   * 환불미완료
   */
  NO_REFUND = "환불미완료",

  /**
   * @notice 배터리 상태
   */

  /**
   * 예약신청
   */
  BEFORE_APPLICATION = "예약신청",
  /**
   * 예약확정
   * 주문확정
   */
  COMPLETED_APPLICATION = "주문확정",
  /**
   * 작업완료
   * 구매확정
   */
  COMPLETED_DISPATCH = "구매확정",
  /**
   * 예약취소
   * 출동 후
   */
  CANCELLATION_AFTER_DISPATCH = "출동후취소",
  /**
   * 예약취소
   * 출동 전
   */
  CANCELLATION_BEFORE_DISPATCH = "출동전취소",
  /**
   * 예약취소
   * 자체취소
   */
  CANCELLATION_SELF_ORDER = "자체취소",
}

/**
 * 주문상태 key type
 */
export type OrderStatusType = keyof typeof OrderStatus;

/**
 * 주문상태 코드 enum
 *
 * -- 카테1
 * @code 1xx - 결제 상태
 * @code 2xx - 주문 진행 상태
 * @code 3xx - 취소 및 반품
 * @code 4xx - 환불
 *
 * -- 카테2
 * @code x0x - 기본
 * @code x1x - 출고
 * @code x2x - 작업
 * @code x3x - 배송
 * @code x4x - 구매
 * @code x5x - 발급
 * @code x6x - 기간
 * @code x7x - 사용
 *
 * -- 카테3
 * @code xx0 - 취소
 * @code xx1 - 완료
 * @code xx2 - 요청
 * @code xx3 - 응답
 * @code xx4 - 실패
 * @code xx9 - 대기
 */
export enum OrderStatusCode {
  /**
   * @notice 공통
   */
  /**
   * 주문취소
   */
  CANCELED_ORDER = 300,
  /**
   * 결제완료
   */
  COMPLETED_PAYMENT = 101,
  /**
   * 주문확정
   */
  CONFIRMED_ORDER = 201,
  /**
   * 출고의뢰
   */
  REQUESTED_GOODS_ISSUE = 212,
  /**
   * 출고완료
   */
  COMPLETED_GOODS_ISSUE = 213,
  /**
   * 작업완료
   */
  COMPLETED_SERVICE = 221,
  /**
   * 배송완료
   */
  COMPLETED_DELIVERY = 231,
  /**
   * 구매확정
   */
  CONFIRMED_PURCHASE = 241,

  /**
   * @notice 세차권
   */
  /**
   * 발급취소 - 환불완료
   */
  CANCELED_ISSUE = 350,
  /**
   * 발급완료
   *
   */
  COMPLETED_ISSUE = 251,
  /**
   * 기간만료
   */
  EXPIRED = 394,
  /**
   * 사용완료
   */
  USED = 271,
  /**
   * 사용완료확인
   */
  CONFIRMED_USING = 273,

  /**
   * @notice 반품요청
   */
  /**
   * 반품요청
   */
  REQUESTED_RETURN = 302,
  /**
   * 반품승인
   */
  CONFIRMED_RETURN = 303,
  /**
   * 회수신청
   */
  APPLIED_RETURN = 339,
  /**
   * 회수완료
   */
  COMPLETED_DELIVERY_RETURN = 331,
  /**
   * 반품완료
   */
  COMPLETED_RETURN = 301,

  /**
   * @notice 환불
   */
  /**
   * 환불완료
   */
  COMPLETED_REFUND = 401,
  /**
   * 환불미완료
   */
  NO_REFUND = 409,

  /**
   * @notice 배터리 상태
   */

  /**
   * 예약신청
   */
  BEFORE_APPLICATION = 202,
  /**
   * 예약확정
   * 주문확정
   */
  COMPLETED_APPLICATION = 201,
  /**
   * 작업완료
   * 구매확정
   */
  COMPLETED_DISPATCH = 241,
  /**
   * 예약취소
   * 출동 후
   */
  CANCELLATION_AFTER_DISPATCH = 302,
  /**
   * 예약취소
   * 출동 전
   */
  CANCELLATION_BEFORE_DISPATCH = 301,
  /**
   * 예약취소
   * 자체취소
   */
  CANCELLATION_SELF_ORDER = 300,
}

/**
 * 주문상태별 컬러
 */
export const orderStatusTypeColor: {
  [key: string]: string;
} = {
  CANCELED_ORDER: color.red3,
  COMPLETED_PAYMENT: color.gray2,
  CONFIRMED_ORDER: color.primary3,
  REQUESTED_GOODS_ISSUE: color.green2,
  COMPLETED_GOODS_ISSUE: color.blue2,
  COMPLETED_SERVICE: color.gray2,
  COMPLETED_DELIVERY: color.gray2,
  CONFIRMED_PURCHASE: color.gray2,
  CANCELED_ISSUE: color.red3,
  COMPLETED_ISSUE: color.gray2,
  EXPIRED: color.gray2,
  USED: color.gray2,
  CONFIRMED_USING: color.gray2,
  REQUESTED_RETURN: color.red3,
  CONFIRMED_RETURN: color.gray2,
  APPLIED_RETURN: color.gray2,
  COMPLETED_DELIVERY_RETURN: color.gray2,
  COMPLETED_RETURN: color.gray2,
  COMPLETED_REFUND: color.blue2,
  NO_REFUND: color.red3,
};

interface OrderStatusTagProps {
  value: OrderStatusType;
  size?: TagSizes;
}

/**
 * 주문상태 태그
 * @param value
 * @returns
 */
export const OrderStatusTag: React.FC<OrderStatusTagProps> = ({
  value,
  size = "medium",
}) => {
  const targetColor = useMemo(
    () => orderStatusTypeColor[value] || color.gray4,
    [value]
  );
  return (
    <>
      {OrderStatus[value] ? (
        <TextTag size={size} colors={targetColor}>
          {OrderStatus[value]}
        </TextTag>
      ) : (
        "-"
      )}
    </>
  );
};
